// Mixin for cryptoWithdraw.vue
import { required, cryptoWalletAddress, min_value } from '@validations'
import Ripple from 'vue-ripple-directive'
import { QrcodeStream } from 'vue-qrcode-reader'
import CopyToClipboard from 'vue-copy-to-clipboard'
import moment from '@/libs/moment'
import CustomerWalletApis from '@/modules/crypto/services/apis/customer-wallet'
import { toEnglishDigits, numberWithCommas, toFixed } from '@/utils'

const GetDescription = () => import(`@/views/${process.env.VUE_APP_THEME_NAME}/components/getDescription.vue`)

const customerWallet = new CustomerWalletApis()

export default {
  components: {
    QrcodeStream,
    GetDescription,
    CopyToClipboard,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      overlay: {
        main: false,
        withdraw: false,
      },
      show: false,
      confirmModal: false,
      confirmPending: false,
      required,
      min_value,
      cryptoWalletAddress,
      coinInfo: {},
      symbol: '',
      coin: '',
      quantity: '',
      decimals: '',
      network: '',
      price: '',
      fee: '',
      getFeeLoading: false,
      destinationAddress: '',
      sourceAddress: '',
      cards: [],
      currency: '',
      amount: '',
      status: '',
      date: '',
      items: [],
      result: '',
      error: '',
      showBarcode: false,
      otpModal: false,
      resendOtpLoading: false,
      verifyLoading: false,
      confirmCode: '',
      tradingPassword: '',
      verifyCounter: 0,
      modalInvoiceColumns: null,
      helpers: {
        numberWithCommas,
        toFixed,
      },
      totalTransactions: 0,
      currentpageTransactions: 1,
      perPageTransactions: 10,
      selectedTransactionId: '',
      selectedTransactionNetwork: '',
      pop2: false,
      transactionIdModal: false,
      networkOptions: [],
      statusModal: false,
      withdrawalStatus: 'pending',
      timer: 120,
      intervalId: null,
      cancelWithdrawalLoading: false,
      newlyCreatedWithdrawal: {},
      senderModal: false,
      otpSenderWay: 'sms',
    }
  },

  computed: {
    isEnableSecurityPassword() {
      return process.env.VUE_APP_ENABLE_SECURITY_PASSWORD === 'true'
    },
    isCancelDisabled() {
      return this.timer <= 0
    },
    fields() {
      return [
        {
          label: this.$t('coin'),
          key: 'currency',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('Network'),
          key: 'network',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('amount'),
          key: 'amount',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('date'),
          key: 'created_at',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('status'),
          key: 'status',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('transaction_id'),
          key: 'transaction_id',
          tdClass: 'nameOfTheClass',
        },
      ]
    },
    mobile() {
      return this.$store.state.profile.profileInfo.mobile
    },
    invoiceHeader() {
      return [
        {
          key: 'address',
          label: this.$t('address'),
        },
        {
          key: 'network',
          label: this.$t('Network'),
        },
        {
          key: 'currency',
          label: this.$t('currency'),
        },
        {
          key: 'amount',
          label: this.$t('Amount'),
        },
        {
          key: 'fee',
          label: this.$t('Fee'),
        },
        {
          key: 'total',
          label: this.$t('total'),
        },
      ]
    },
  },

  watch: {
    pop2(val) {
      if (val) {
        setTimeout(() => {
          this.pop2 = false
        }, 2500)
      }
    },
    currentpageTransactions(val) {
      if (val) {
        this.getWalletTransactions()
      }
    },
    network(val) {
      this.fee = this.coinInfo.currency_network?.find(item => item.network.nick_name === val)?.commission
    },
    confirmModal(val) {
      if (val) {
        this.getFee()
      }
    },
  },

  mounted() {
    if (this.$route.params.coin_name && this.$route.params.coin_symbol) {
      this.overlay.main = true
      this.overlay.withdraw = true
      customerWallet.getCoin(this.$route.params.coin_symbol).then(coin => {
        this.coinInfo = coin.data.results
        this.network = coin.data.results.currency_network[0].network.nick_name
        this.symbol = this.$route.params.coin_symbol
        this.coin = this.$route.params.coin_name
      }).finally(() => {
        this.overlay.main = false
      })

      customerWallet.getUserWallets({ currency: this.$route.params.coin_symbol }).then(res => {
        this.quantity = res.data.results[0].quantity
        this.decimals = res.data.results[0].currency_network[0]?.exchange.quantity_decimal_for_wallet
      })

      this.getWalletTransactions().finally(() => {
        this.overlay.withdraw = false
      })
    } else {
      this.$router.push(`/${this.$i18n.locale}/crypto-wallets`)
    }
  },

  methods: {
    sendVerificationCodeMethod(way) {
      this.otpSenderWay = way
    },
    openConfirmModal() {
      this.confirmPending = true

      const obj = {
        amount: toEnglishDigits(this.price),
        address: this.destinationAddress,
        currency: this.symbol,
        network: this.network,
        sender: this.otpSenderWay,
      }

      customerWallet.withdrawalSendCode(obj).then(() => {
        this.verifyCounter = 60
        this.countDownTimer()
        this.otpModal = true
      }).finally(() => {
        this.confirmPending = false
      })
    },
    async getWalletTransactions() {
      this.show = true
      return await customerWallet.withdrawTransactions({
        current_page: this.currentpageTransactions,
        per_page: this.perPageTransactions,
      }).then(res => {
        this.totalTransactions = res.data.results.paginate.total
        this.currentpageTransactions = res.data.results.paginate.current_page
        this.perPageTransactions = Number(res.data.results.paginate.per_page)
        this.items = res.data.results.data.map(itm => ({ ...itm, cancelLoading: false }))
        return res
      }).finally(() => {
        this.show = false
      })
    },
    getFormattedDate(date) {
      return moment(date).format('YYYY-MM-DD')
    },
    onDecode(result) {
      this.result = result
      this.destinationAddress = result
      this.showBarcode = false
      this.error = ''
    },

    async onInit(promise) {
      try {
        await promise
      } catch (error) {
        this.showBarcode = false
        if (error.name === 'NotAllowedError') {
          this.error = 'barcodeError.camera-access'
        } else if (error.name === 'NotFoundError') {
          this.error = 'barcodeError.camera-error'
        } else if (error.name === 'NotReadableError') {
          this.error = 'barcodeError.use-camera'
        } else if (error.name === 'OverconstrainedError') {
          this.error = 'barcodeError.camera-installed'
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = 'barcodeError.not-support'
        } else if (error.name === 'InsecureContextError') {
          this.error = 'barcodeError.use-HTTPS'
        } else {
          this.error = `ERROR: Camera error (${error.name})`
        }
      }
    },
    resendSMS() {
      this.resendOtpLoading = true

      const obj = {
        amount: toEnglishDigits(this.price),
        address: this.destinationAddress,
        currency: this.symbol,
        network: this.network,
        sender: this.otpSenderWay,
      }

      customerWallet.withdrawalSendCode(obj).then(({ data }) => {
        this.verifyCounter = 60
        this.countDownTimer()
        this.$swal({
          title: data?.message,
          icon: 'success',
          timer: 2500,
          showConfirmButton: false,
        })
      }).finally(() => {
        this.resendOtpLoading = false
      })
    },
    verify() {
      this.verifyLoading = true
      const obj = {
        amount: toEnglishDigits(this.price),
        address: this.destinationAddress,
        currency: this.symbol,
        network: this.network,
        code: this.confirmCode,
        trading_password: this.tradingPassword,
      }

      customerWallet.withdrawalCryptoWallet(obj).then(({ data }) => {
        this.confirmModal = false
        this.otpModal = false
        this.statusModal = true
        this.newlyCreatedWithdrawal = data.results
        this.timer = data.results.remaining_cancellation_time
        this.startTimer()
      }).finally(() => {
        this.verifyLoading = false
      })
    },
    countDownTimer() {
      if (this.verifyCounter > 0) {
        setTimeout(() => {
          this.verifyCounter -= 1
          this.countDownTimer()
        }, 1000)
      }
    },
    setInvoiceDetails() {
      this.confirmModal = true
      this.modalInvoiceColumns = [{
        address: this.destinationAddress,
        network: this.network,
        currency: this.coin,
        amount: this.helpers.numberWithCommas(this.price),
        fee: this.fee,
        total: this.helpers.numberWithCommas(Number(this.price) - Number(this.fee)),
      }]
    },

    triggerTransactionModal({ transaction, network }) {
      this.transactionIdModal = true
      this.selectedTransactionId = transaction
      this.selectedTransactionNetwork = network
    },
    openTransaction() {
      if (this.selectedTransactionNetwork === 'TRC20' && this.selectedTransactionId) {
        window.open(`https://tronscan.org/#/transaction/${this.selectedTransactionId}`, '_blank')
      } else if (this.selectedTransactionNetwork === 'BSC' && this.selectedTransactionId) {
        window.open(`https://bscscan.com/tx/${this.selectedTransactionId}`, '_blank')
      }
      this.transactionIdModal = false
    },
    copyTransaction() {
      this.pop2 = true
    },
    cancelWithdrawal(Wid) {
      const item = this.items.find(itm => itm.id === Wid)
      if (item) {
        item.cancelLoading = true
      } else {
        this.cancelWithdrawalLoading = true
      }
      customerWallet.cancelWithdrawalCrypto({ withdrawal_id: Wid }).then(({ data }) => {
        this.$swal({
          title: data?.message,
          icon: 'success',
          timer: 2500,
          showConfirmButton: false,
        })
        if (item) {
          item.remaining_cancellation_time = 0
        }
        this.time = 0
        this.statusModal = false
        this.getWalletTransactions()
      }).finally(() => {
        if (item) {
          item.cancelLoading = false
        } else {
          this.cancelWithdrawalLoading = false
        }
      })
    },
    startTimer() {
      this.intervalId = setInterval(() => {
        if (this.timer > 0) {
          this.timer -= 1
        } else {
          clearInterval(this.intervalId)
          this.statusModal = false
        }
      }, 1000)
    },
    getFee() {
      if (this.price && this.network) {
        this.getFeeLoading = true
        this.fee = null
        customerWallet.getWithdrawalFee({
          amount: toEnglishDigits(this.price),
          address: this.destinationAddress,
          currency: this.symbol,
          network: this.network.toLowerCase(),
        }).then(({ data }) => {
          this.fee = data.results.fee
        }).finally(() => {
          this.getFeeLoading = false
        })
      } else {
        this.fee = 0
      }
    },
  },
}
